<template>
  <div class="background"
    style="height: 980px !important;"
  >
    <v-carousel 
      cycle
      :show-arrows="false" 
      hide-delimiters
      height="980"
      :interval="enterpriseID === 'e91572db-6dfd-4c59-8554-19b2058e67a3' || enterpriseID === '72c0948f-7eef-4d82-ab84-f94862c7a37f' ? 60000 : 6000"
    >
      <v-carousel-item
        v-for="(item,i) in images"
        :key="i"
        :src="item"
      />
    </v-carousel>
  </div>
</template>
<script>
import axios from 'axios'
import { parseString } from 'xml2js'
export default {
  props: {
    enterpriseTotemBackground: {
      type: String,
      default: `https://www.dviewcontent.com/image/result/06_8f01ee10-1fdb-11ec-b877-1dbb98d39c7b.xml`,
    },
    enterprise: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    images: null,
  }),
  computed: {
    enterpriseID () {
      return this.enterprise ? this.enterprise.ID : null
    },
  },
  watch: {
    enterpriseTotemBackground (v) {
      this.getImages()
    },
  },
  mounted () {
    console.log('jhm', this.enterpriseID, 
      this.enterpriseID === 'e91572db-6dfd-4c59-8554-19b2058e67a3' || this.enterpriseID === '72c0948f-7eef-4d82-ab84-f94862c7a37f' ? 3600000 : 6000
    )
    this.getImages ()
  },
  methods: {
    getImages () {
      axios.get(this.enterpriseTotemBackground)// && this.enterpariseTotemBackground !== undefined ? this.enterpriseTotemBackground : `https://www.dviewcontent.com/image/result/06_8f01ee10-1fdb-11ec-b877-1dbb98d39c7b.xml`)
        .then (response => {
          try {
            const that = this
            parseString (response.data, (err, results) => {
            // parsing to json
              that.images = []
              that.images = results.rss.channel.shift().item.map(item => {
                return item['media:content'].shift()['$'].url
              }).filter(x => x.indexOf('.mp4') === -1)
            })
          } catch (error) {
           console.log(error)
          }
        })
    },
  }
}
</script>
<style scoped>
.background {
  position: relative;
}
</style>

